export default __webpack_public_path__ + "static/media/call.4d8a0c6a.svg";